import store from 'app/store';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: ['admin', 'sub-admin', 'producer', 'sub-producer', 'producer_business'],
    routes: [
        {
            path: '/monthly-pay-reports',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./AdminMonthlyPayReportsApp');
                        case 'producer':
                        case 'sub-producer':
                            return import('./ProducerMonthlyPayReportsApp');
                        case 'producer_business':
                            return import('./producer-business/ProducerBusinessMonthlyPayReportsApp');
                        default:
                            break;
                    }
                },
            }),
        },
        {
            path: '/producer-business-pay-reports',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./producer-business/AdminProducerBusinessPayReports');
                        default:
                            break;
                    }
                },
            }),
        },
    ],
};

export default [Index];
